// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__mnmpN","secondary":"Text_secondary__PA5vI","strong":"Text_strong__r5tcD","italic":"Text_italic__4jMOD"};